// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__2tPnj","img":"Arrow_img__2Xe4t","left":"Arrow_left__w-dXQ","right":"Arrow_right__GW5Jb","show":"Arrow_show__9iNmK","hide":"Arrow_hide__Zv7v9"};